import { render, staticRenderFns } from "./LhcAmIndexZhiliao.vue?vue&type=template&id=adc8ab6e&scoped=true&"
import script from "./LhcAmIndexZhiliao.vue?vue&type=script&lang=js&"
export * from "./LhcAmIndexZhiliao.vue?vue&type=script&lang=js&"
import style0 from "./LhcAmIndexZhiliao.vue?vue&type=style&index=0&id=adc8ab6e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc8ab6e",
  null
  
)

export default component.exports